import { useFeatureFlags } from 'features/FeatureFlags'

import { useOutstandingFilterContext } from '../../context/useOutstandingFilterContext'
import { useToggleOutstandingExpensesFilter } from './useToggleOutstandingExpensesFilter/useToggleOutstandingExpensesFilter'

export const useToggleOutstandingFilter = () => {
  const flags = useFeatureFlags()
  const { toggleIsOutstandingFilter } = useOutstandingFilterContext()
  const {
    resetFilter: resetOutstandingExpensesFilter,
    toggleFilter: toggleOutstandingExpensesFilter,
  } = useToggleOutstandingExpensesFilter()

  return {
    toggleFilter: flags.CorpCardsSettings
      ? toggleIsOutstandingFilter
      : toggleOutstandingExpensesFilter,
    resetFilter: flags.CorpCardsSettings
      ? undefined
      : resetOutstandingExpensesFilter,
  }
}
